/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Common_Error_Rate_LimitedInputs */

const en_common_error_rate_limited = /** @type {(inputs: Common_Error_Rate_LimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Too many requests — please retry after ${i?.duration}.`)
};

const zh_common_error_rate_limited = /** @type {(inputs: Common_Error_Rate_LimitedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`请求过于频繁,请在 ${i?.duration} 后重试。`)
};

/**
* | output |
* | --- |
* | "Too many requests — please retry after {duration}." |
*
* @param {Common_Error_Rate_LimitedInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_error_rate_limited = /** @type {((inputs: Common_Error_Rate_LimitedInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Error_Rate_LimitedInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_error_rate_limited(inputs)
	return zh_common_error_rate_limited(inputs)
});
export { common_error_rate_limited as "common.error.rate_limited" }